module.exports = __webpack_public_path__ + "files/2e7db2773859424f5e24b04064347d4d.png";